var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ContentWithSidebar',{attrs:{"sections":_vm.sections,"groupKeys":_vm.groupKeys,"settings":_vm.settings,"widgets":_vm.widgets}})}
var staticRenderFns = []

export { render, staticRenderFns }